







import { Component, Vue } from 'vue-property-decorator';
import HelloHeart from '@/components/HelloHeart.vue'; // @ is an alias to /src

@Component({
  components: {
    HelloHeart,
  },
})
export default class Home extends Vue {}
